import React, { useState, useEffect } from 'react';
import './NewTabPanel.css';
import NewTab from './NewTab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function NewTabPanel({ children, tabClass, selectedTabClass, separatorClass, panelClass, showPanel }) {
  const [visiblePanelTitle, setVisiblePanelTitle] = useState(showPanel ? showPanel : children[0].props.title);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  if (logComponent('NewTabPanel')) { console.debug('NewTabPanel rendered'); }


  useEffect(() => {
    if (logComponent('NewTabPanel')) { console.debug('NewTabPanel useEffect [showPanel]'); }
   if(showPanel) selectPanel(showPanel);
  }, [showPanel])


  const selectPanel = (panelTitle) => {
    if (logComponent('NewTabPanel')) { console.debug('NewTabPanel selectPanel'); }
   setVisiblePanelTitle(panelTitle);
  }

  const selectPanelFromDropdown = (e) => {
    if (logComponent('NewTabPanel')) { console.debug('NewTabPanel selectPanelFromDropdown'); }
   const { panel } = e.target.dataset;

    setVisiblePanelTitle(panel);
    toggleDropdown();
  }

  const toggleDropdown = () => {
    if (logComponent('NewTabPanel')) { console.debug('NewTabPanel toggleDropdown'); }
   setDropdownVisible(!dropdownVisible);
  }

  const hideDropdown = () => {
    if (logComponent('NewTabPanel')) { console.debug('NewTabPanel hideDropdown'); }
    setDropdownVisible(false);

  }

  return (
    <div className="New-Tab-Panel">
      {/* sm */}
      <div className="New-Tab-Panel__dropdown">
        <div
          className="New-Tab-Panel__dropdown-everpresent"
          onClick={toggleDropdown}
          onBlur={hideDropdown}>
          <span className="New-Tab-Panel__dropdown-selected-item">{visiblePanelTitle}</span>
          {
            dropdownVisible ?
              <FontAwesomeIcon className="New-Tab-Panel__dropdown-expand-icon" icon="chevron-circle-down" /> :
              <FontAwesomeIcon className="New-Tab-Panel__dropdown-retract-icon" icon="chevron-down" />
          }

        </div>
        <ul
          className={'New-Tab-Panel__dropdown-overlay' + (dropdownVisible ? ' New-Tab-Panel__dropdown-overlay--visible' : '')}>
          {
            children
              .filter(child => !child.props.hideIf)
              .map((child, index) =>
                <li
                  className="New-Tab-Panel__dropdown-item"
                  key={child.props.title}
                  data-panel={child.props.title}
                  onClick={selectPanelFromDropdown}>
                  {child.props.title}
                </li>
              )
          }
        </ul>
      </div>

      {/* md-above */}
      <ul className="New-Tab-Panel__tabs">
        {
          children
            .filter(child => !child.props.hideIf)
            .map((child, index) =>
              <NewTab
                key={index}
                title={child.props.title}
                selectPanel={selectPanel}
                isSelected={child.props.title === visiblePanelTitle}
                baseClass={tabClass}
                selectedClass={selectedTabClass} />
            )
        }
      </ul>
      <div className={'New-Tab-Panel__separator' + (separatorClass ? ' ' + separatorClass : '')}></div>
      <div className={'New-Tab-Panel__panels' + (panelClass ? ' ' + panelClass : '')}>
        {
          children.map((child, index) =>
            <div
              key={index}
              className={'New-Tab-Panel__panel' + (child.props.title === visiblePanelTitle ? ' New-Tab-Panel__panel--selected' : '')}>{child}</div>
          )
        }
      </div>
    </div>
  );
}